var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center"},[_c('v-row',[(_vm.registStatus)?_c('v-col',[_vm._v(" 受講登録が完了しました。 ")]):_c('v-col',[_vm._v(" すでに登録されている講座です。 ")])],1),_c('v-row',[_c('v-col',{attrs:{"justify":"center"}},[_c('v-btn',{attrs:{"small":"","color":"error"},on:{"click":_vm.moveToMyapage}},[_vm._v(" マイページへ移動 ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }